(function ($) {
  const generic = window.generic || {};
  const prefixFormat = 'fr';
  const prefixes = {
    de_CH: '',
    fr_CH: 'fr'
  };
  const path = location.pathname;
  const pathPrefix = path.substring(1, prefixFormat.length + 1);
  const fullHref = location.host + location.pathname + location.search + location.hash;

  function initializeLanguageCH() {
    const localeCookie = generic.cookie('LOCALE');

    if (pathPrefix && Object.values(prefixes).includes(pathPrefix)) {
      document.cookie = 'LOCALE=; expires=Thu, 01 Jan 1970 00:00:01 GMT;';
      generic.cookie('LOCALE', path.substring(1, 3) + '_CH', { path: '/' });
    } else if (!path.includes('.tmpl') && prefixes[localeCookie]) {
      location.href = location.protocol + '//' + fullHref.replace(location.host, location.host + '/' + prefixes[localeCookie]);
    }
  }

  initializeLanguageCH();
  $(document).on('csrf.success', initializeLanguageCH);

  $('.js-switch-lang-link').once().on('click', function (switchLangEvent) {
    switchLangEvent.preventDefault();
    const lang = $(this).attr('data-mp-lang') + '_CH';
    const localeCookie = generic.cookie('LOCALE');

    if (localeCookie === lang) {
      return;
    }

    document.cookie = 'LOCALE=; expires=Thu, 01 Jan 1970 00:00:01 GMT;';
    generic.cookie('LOCALE', lang, { path: '/' });

    if (path.includes('.tmpl')) {
      return location.reload();
    }

    if (prefixes[lang] !== undefined) {
      let targetHref = fullHref.replace(new RegExp('/' + prefixFormat, 'u'), '');

      targetHref = targetHref.replace(location.host, location.host + '/' + prefixes[lang]);
      targetHref = targetHref.replace(/\/+/gu, '/');

      location.href = location.protocol + '//' + targetHref;
    }
  });
})(jQuery);
